import React from 'react';

import { ModalBullet } from '../ModalBullet';

import styles from './index.module.scss';

const BULLETS = [
  'All-in-one research suite',
  'Advanced automated analytics',
  'Access to millions of global consumers',
  'Team collaboration'
];

export const ProTrialRightSection: React.FunctionComponent = () => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <p><b>For deeper learning and more powerful insights across your organization.</b></p>
        <p>Everything in Lite, plus...</p>
        <div className={styles.bullets}>
          {BULLETS.map((bullet, index) => (
            <ModalBullet key={`${bullet}-${index}`} content={bullet} />
          ))}
        </div>
      </div>
    </section>
  );
};
